import { render, staticRenderFns } from "./06_relativeContacts.vue?vue&type=template&id=3ca55663"
import script from "./06_relativeContacts.vue?vue&type=script&lang=js"
export * from "./06_relativeContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports